import { useEffect, useState } from 'react';
import styles from './Familiales.module.css';
import { EventModel } from '../models/EventModel';
import { Helmet } from 'react-helmet-async';
import SubscriptionSection from '../components/SubscriptionSection';
import EventItem from '../components/EventItem';
import { Link } from 'react-router-dom';

export default function Familiales() {

    const preloaded = (window as any).__FAMILY_EVENTS__ ?? {};
    console.log(preloaded);
    const [eventsToday, setEventsToday] = useState<EventModel[]>(preloaded.today || []);
    const [eventsThisWeek, setEventsThisWeek] = useState<EventModel[]>(preloaded.thisWeek || []);

    useEffect(() => {
        setEventsToday(preloaded.today || []);
        setEventsThisWeek(preloaded.thisWeek || []);
    }, [preloaded]);

    const title = `Activités familiales à Québec – Activités pour toute la famille aujourd’hui et cette semaine`;
    const description = `Découvrez toutes les activités familiales à Québec : ateliers, expositions, festivals et activités à faire en famille aujourd’hui et cette semaine. Mis à jour en continu.`;

    return <div style={{position: 'relative'}}>
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={location.href} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
        </Helmet>
        <SubscriptionSection stickyBanner={true}/>
        <h1>Activités familiales à Québec</h1>
        <p>Vous cherchez des activités pour toute la famille à Québec ?
        Sur alentours, découvrez toutes les activités à faire en famille à Québec : ateliers, expositions, activités culturelles, festivals et sorties pour toute la famille aujourd’hui et cette semaine. Cette page est mise à jour en continu pour vous proposer des activités partout dans la ville de Québec.</p>

        <h2>Activités familiales à Québec aujourd’hui</h2>
        <div className={styles.eventsContainer}>
            {eventsToday.length == 0 && <div>
                <p>Il n'y a aucune activité familiale aujourd'hui. </p>
                </div>}
            {eventsToday.map(e => 
                <EventItem event={e} />
            )}
        </div>
        <div style={{display:"flex", justifyContent: "center", gap: "20px", flexDirection: "column"}}>
            <Link to="/ville-quebec/aujourdhui" reloadDocument><button type="button" className={styles.searchBtn}>Voir tous les événements aujourd'hui</button></Link>
        </div>

        <h2>Activités familiales à Québec cette semaine</h2>
        <div className={styles.eventsContainer}>
            {eventsThisWeek.length == 0 && <div>
                <p>Il n'y a aucune activité familiale cette semaine. </p>
                </div>}
            {eventsThisWeek.map(e => 
                <EventItem event={e} />
            )}
        </div>

        <h2>Certaines activités vous sont proposées grâce au soutien de la Ville de Québec, d’organismes culturels ou d’initiatives citoyennes. Tout au long de l’année, de nombreux lieux proposent des événements accessibles pour toute la famille.</h2>

        <div style={{display:"flex", justifyContent: "center", gap: "20px", flexDirection: "column"}}>
            <Link to="/ville-quebec/evenements-cette-semaine" reloadDocument><button type="button" className={styles.searchBtn}>Voir tous les événements de cette semaine</button></Link>
            <Link to="/#search"><button type="button" className={styles.searchBtn}>Rechercher parmi tous les événements</button></Link>
        </div>
        <SubscriptionSection />
    </div>;

}